export default {
  en: {
    'GROUP_BY_PLACEHOLDER': 'Select'
  }
};